import withActivityErrorBoundary from '$app-web/hoces/with-activity-error-boundary';
import loadable, { withTimeoutAndDelay } from '$app-web/utils/lazy-load';

export default withActivityErrorBoundary('sopro-report-chart')(
    loadable(() => withTimeoutAndDelay(() => import('./component')), true)
);
